"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var memoize = require('lodash/memoize');
exports.isFirefox = memoize(function () { return /firefox/i.test(navigator.userAgent); });
exports.isSafari = memoize(function () { return Boolean(window.safari); });
//# sourceMappingURL=BrowserDetector.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-html5-backend/lib/BrowserDetector.js
// module id = 511
// module chunks = 0